<template>
  <div class="sidebar">
    <!-- Logo 区域 -->
    <div class="sidebar-logo">
      <img src="@/assets/logo.png" alt="Logo" class="logo-img" v-if="sidebar.opened" />
      <img src="@/assets/logo-mini.png" alt="Logo" class="logo-img-mini" v-else />
      <span class="logo-text" v-if="sidebar.opened">新迈管理后台</span>
    </div>

    <!-- 菜单区域 -->
    <el-menu
      :key="menuKey"
      :default-active="activeMenu"
      :collapse="!sidebar.opened"
      :unique-opened="true"
      :collapse-transition="false"
      background-color="#304156"
      text-color="#bfcbd9"
      active-text-color="#409EFF"
      router
      class="sidebar-menu"
    >
      <template v-for="route in menuRoutes">
        <SidebarItem v-if="!route.hidden" :key="route.path" :item="route" :base-path="route.path" />
      </template>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SidebarItem from "./SidebarItem.vue";

export default {
  name: "SidebarComponent",
  components: {
    SidebarItem,
  },
  computed: {
    ...mapGetters("app", ["sidebar"]),
    ...mapGetters("user", ["permissions"]),
    userRole() {
      return this.$store.state.user.userInfo?.role || "";
    },
    menuKey() {
      return this.userRole + '|' + [...this.permissions].sort().join(',');
    },
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    menuRoutes() {
      const canShow = meta => {
        if (!meta) return true;
        if (meta.permission) return this.permissions.has(meta.permission);
        if (meta.permissions) return meta.permissions.some(p => this.permissions.has(p));
        if (meta.roles) return meta.roles.includes(this.userRole);
        return true;
      };
      return this.$router.options.routes
        .filter(route => !route.hidden && canShow(route.meta))
        .map(route => {
          if (!route.children) return route;
          const filteredChildren = route.children.filter(c => !c.hidden && canShow(c.meta));
          return { ...route, children: filteredChildren };
        })
        .filter(route => !route.children || route.children.length > 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  height: 100%;
  background-color: #304156;
  width: 100%;

  .sidebar-logo {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #2b2f3a;
    border-bottom: 1px solid #434a50;

    .logo-img {
      height: 32px;
      margin-right: 8px;
    }

    .logo-img-mini {
      height: 32px;
    }

    .logo-text {
      color: #fff;
      font-size: 16px;
      font-weight: bold;
    }
  }

  .sidebar-menu {
    border-right: none;
    height: calc(100% - 60px);
    overflow-y: auto;

    // 菜单项样式优化
    .el-menu-item {
      height: 50px;
      line-height: 50px;

      &:hover {
        background-color: #263445 !important;
      }

      &.is-active {
        background-color: #409eff !important;
        color: #fff !important;

        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          width: 3px;
          background-color: #409eff;
        }
      }
    }

    // 子菜单样式
    .el-submenu {
      .el-submenu__title {
        height: 50px;
        line-height: 50px;

        &:hover {
          background-color: #263445 !important;
        }
      }

      .el-menu-item {
        height: 45px;
        line-height: 45px;
        padding-left: 50px !important;

        &:hover {
          background-color: #263445 !important;
        }

        &.is-active {
          background-color: #409eff !important;
          color: #fff !important;
        }
      }
    }
  }
}

// 滚动条样式
.sidebar .el-menu::-webkit-scrollbar {
  width: 6px;
}

.sidebar .el-menu::-webkit-scrollbar-track {
  background: #304156;
}

.sidebar .el-menu::-webkit-scrollbar-thumb {
  background: #434a50;
  border-radius: 3px;
}

.sidebar .el-menu::-webkit-scrollbar-thumb:hover {
  background: #5a6169;
}
</style>
